import { DateISO, Pagination } from 'api/interfaces';
import { get, post } from 'api/methods';

export interface UserCooperativa {
  codCooperativa: string;
  nomeCooperativa: string;
}

export type CooperativasUsuarioResponse = Array<UserCooperativa>;

export interface ListagemLoginsRequest {
  coop: string;
  cpf: string;
  fimCreatedAt: string;
  fimLastLogin: string;
  fimLastLoginInvalid: string;
  iniCreatedAt: string;
  iniLastLogin: string;
  iniLastLoginInvalid: string;
  nome: string;
}

export interface LoginPessoaConta {
  coop: string;
  numero: string;
  ua: string;
}

export interface LoginPessoaResponse {
  active: string;
  contas: Array<LoginPessoaConta>;
  cpf: string;
  createdAt: string;
  lastLogin: string;
  lastLoginInvalid: string;
  nome: string;
}

export type ListagemLoginsResponse = Pagination<LoginPessoaResponse>;

export interface UsuarioCadastrosRequest {
  coop: string;
  cpfOrNome: string;
  dataFimCadastro: DateISO;
  dataInicioCadastro: DateISO;
}

export interface UsuarioCadastrosItem {
  contas: {
    agencia: string;
    carteira: string;
    conta: string;
    cooperativa: string;
    cpfCnpj: string;
    nomeAssociado: string;
    nucleo: string;
    relacionamento: string;
  };
  cooperativa: string;
  cpfLogin: string;
  dataCadastro: DateISO;
  dataUltimoAcesso: DateISO;
  idUsuarioLogin: number;
  nomeLogin: string;
}

export type UsuarioCadastrosResponse = Pagination<UsuarioCadastrosItem[]>;

export interface ContaUsuario {
  agencia: string;
  conta: string;
  cpfCnpj: string;
  nomeAssociado: string;
  nucleo: string;
  carteira: string;
  relacionamento: 'ASSOCIADO' | 'REPRESENTANTE' | 'NAO_ASSOCIADO';
}

export type ContasUsuarioResponse = Array<ContaUsuario>;

const usuario = {
  cooperativas: () => {
    return get<CooperativasUsuarioResponse>(
      'assembleiasAssessor',
      'usuario/filtro'
    );
  },
  listagemLogins: (
    data: Partial<ListagemLoginsRequest>,
    page?: number,
    size?: number
  ) => {
    return post<ListagemLoginsResponse>(
      'assembleiasAssessor',
      'usuario/logins-criados',
      data,
      {
        params: { page, size },
      }
    );
  },
  listagemCadastros: (
    data: Partial<UsuarioCadastrosRequest>,
    page?: number,
    size?: number
  ) => {
    return post<UsuarioCadastrosResponse>(
      'assembleiasAssessor',
      'usuario/logins-criados-v2',
      data,
      {
        params: { page, size },
      }
    );
  },
  contasPorUsuario: (idUsuario: number, codigoCooperativa: string) => {
    return get<ContasUsuarioResponse>(
      'assembleiasAssessor',
      `usuario/${idUsuario}/contas`,
      {
        params: { codigoCooperativa },
      }
    );
  },
};

export default usuario;
